import OregonCityPageTemplate from "@/pages/oregon-city/CityPageTemplate";
import { estacadaConfig } from "./data";

export default function EstacadaPage() {
  return <OregonCityPageTemplate config={estacadaConfig} />;
}